export default
{
    mounted()
    {
        this.$label = this.$el.querySelector('.js-label')

        this.animLabel()
    },

    methods:
    {
        animLabel()
        {
            this.$label.style.transform = 'translateX(-150%) translateY(-50%) translateZ(0)'
            this.$label.style.transitionDuration = '6s'

            setTimeout(() =>
            {
                this.$label.style.transform = 'translateX(50%) translateY(-50%) translateZ(0)'
                this.$label.style.transitionDuration = '0s'
            }, 4000)

            setTimeout(() =>
            {
                this.animLabel()
            }, 4500 + this.getRandomInt(0, 3) * 200)
        },

        onToggleNav()
        {
            this.$el.classList.toggle('is-nav-opened')
        },

        onSwitchLang()
        {
            this.$emit('switch:lang')
        },

        getRandomInt(min, max)
        {
            return Math.floor(Math.random() * max) + min
        },
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-nav/script.js